import { useState, useEffect } from 'react';

export function useResponsiveYAxisWidth(desktopWidth) {
  const [w, setW] = useState(
    typeof window !== 'undefined' && window.innerWidth < 640
      ? Math.max(60, Math.round(desktopWidth * 0.55))
      : desktopWidth
  );

  useEffect(() => {
    const h = () =>
      setW(
        window.innerWidth < 640
          ? Math.max(60, Math.round(desktopWidth * 0.55))
          : desktopWidth
      );
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, [desktopWidth]);

  return w;
}
